var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-md bg-white shadow-card w-full flex flex-col pt-8 pl-8 pb-13"},[_c('h4',{staticClass:"text-xl normal font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"w-9 h-1 bg-blue-900 rounded-md mt-4 mb-4"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }